import { computed, ref } from "vue";
import ComponentesService from "@/services/ComponentesService";
import FuncoesHelper from "@/helpers/FuncoesHelper";

import { useStore } from "@/store";
import Actions from '@/store/Actions'
import TiposVeiculosConstant from "@/constants/TiposVeiculosConstant";
import CroquisAvariasConstant from "@/constants/CroquisAvariasConstant";

class ComponenteAvariaService {
    setup({ respostas, respostaObrigatoria, etapaComponente, identificador, modulo, resumoModulos }) {
        const store = useStore();
        const identificadorRota = ref(FuncoesHelper.obterParametrosRota('identificador'));
        const imagensAvarias = ref([]);
        const tipoVeiculoSelecionado = computed(() => store.state.tipoVeiculo);
        const croquisAvarias = ref(CroquisAvariasConstant.CROQUI_VEICULO(tipoVeiculoSelecionado.value));
        const exibirIndicador = ref(true);
        const resposta = ref(respostas);
        const semAvaria = ref(false);
        const statusResposta = ref('');
        const tipoCaminhao = ref(TiposVeiculosConstant.CAMINHAO);
        const preview =  ref(FuncoesHelper.validarChecklistPreview())

        if (resposta.value) {
            croquisAvarias.value = Object.keys(resposta.value).map(key => {
                const resp = resposta.value[key];
                store.dispatch(Actions.SALVAR_TIPO_VEICULO, resp.descricao);
                return {
                    nome: resp.nome,
                    imagem: resp.imagem,
                    idArquivoChecklistModular: resp.idArquivoChecklistModular,
                    id: key,
                    semAvaria: resp?.semAvaria ?? false
                };
            });
            exibirIndicador.value = false;
        }

        croquisAvarias.value = croquisAvarias.value.map(croqui => {
            const avaria = imagensAvarias.value.find(imagem => imagem.nome === croqui.nome);
            if (avaria && avaria.imagem) {
                croqui.imagem = avaria.imagem;
                exibirIndicador.value = false;
            }
            return croqui;
        });

        if (exibirIndicador.value) {
            setTimeout(() => {
                exibirIndicador.value = false;
            }, 7000);
        }
        semAvaria.value = croquisAvarias.value[0]?.semAvaria ?? false;

        if (!resumoModulos) {
            statusResposta.value = ComponentesService.validaStatusRespostaComponente(
                respostaObrigatoria,
                typeof croquisAvarias.value[0]?.idArquivoChecklistModular !== 'undefined' && croquisAvarias.value[0]?.idArquivoChecklistModular !== null
            );
            ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta.value);
        }

        return {
            identificadorRota,
            croquisAvarias,
            idComponente: identificador,
            exibirIndicador,
            semAvaria,
            statusResposta,
            tipoCaminhao,
            preview
        };
    }

    detalheAvariaSetup() {
        const store = useStore();
        const etapaAtual = ref(FuncoesHelper.obterParametrosRota('etapa'))
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))
        const idComponente = ref(FuncoesHelper.obterParametrosRota('idComponente'))
        const modulo = ref(FuncoesHelper.obterParametrosRota('modulo'))
        const localRealizacao = ref(FuncoesHelper.obterParametrosRota('localRealizacao'))
        const tipoVeiculoSelecionado = computed(() => store.state.tipoVeiculo);
        const moduloAtual = computed(() => store.state.modulos.find(module => module.idChecklistModulo == modulo.value))
        const dadosComponentes = ref(moduloAtual.value.etapas.componentes[etapaAtual.value][idComponente.value])
        const croquisAvarias = CroquisAvariasConstant.CROQUI_VEICULO(tipoVeiculoSelecionado.value)

        const larguraDaTela = ref(window.innerWidth * 0.85);
        if (larguraDaTela.value > 430) {
            larguraDaTela.value = 430
        }
        const exibirLoader = ref(false);

        const estadoUltimaMarcacao = ref([]);
        const labelBotaoSalvar = ref('Salvar sem avaria');

        return {
            etapaAtual,
            identificador,
            tipoVeiculoSelecionado,
            croquisAvarias,
            exibirLoader,
            idComponente,
            larguraDaTela,
            dadosComponentes,
            modulo,
            localRealizacao,
            estadoUltimaMarcacao,
            labelBotaoSalvar
        }
    }
}

export default new ComponenteAvariaService();